import { Link, Outlet, useLocation } from "react-router-dom";
import './dashboard.scss';
import Breadcrumbs from "../../../components/breadcrumb/breadcrumb";
import { useAuthentication } from "@myinnsworth/hooks/authenticationHook";
import cardsIcon from '../../../assets/images/cards-icon.svg';
import listIcon from '../../../assets/images/list-icon.svg';
import { useEffect, useState } from "react";
import { ListMode } from "@myinnsworth/models/listHelpers";
import { SortDirection } from "@myinnsworth/models/Search";
import { useDebounce } from 'usehooks-ts'
import clsx from "clsx";

export type DashboardLayoutContext = {
    listMode: ListMode;
    sortDirection: SortDirection;
    searchTerm?: string;
    currentTab: DashboardTab;
};

export type DashboardTab = 'news' | 'investor-updates';

export default function DashboardLayout(props: any) {
    const [listMode, setListMode] = useState<ListMode>(ListMode.Cards);
    const [sortDirection, setSortDirection] = useState<SortDirection>('desc');
    const [currentTab, setCurrentTab] = useState<DashboardTab>('news')
    const [searchTerm, setSearchTerm] = useState<string>('');
    const debouncedValue = useDebounce<string>(searchTerm, 750);
    const authentication = useAuthentication();
    const location = useLocation();

    const breadcrumbs = [
        { label: 'Dashboard', url: '/dashboard/latest-news' },
    ];

    useEffect(() => {
        if (location.pathname === '/dashboard' || location.pathname.includes('latest-news')) {
            setCurrentTab('news');
        } else {
            setCurrentTab('investor-updates');
        }
    }, [location.pathname]);

    return (
        <>
            <h4>
                Welcome Back,
                <br />
                {authentication.user?.displayName}
            </h4>

            <br />

            <Breadcrumbs items={breadcrumbs} />

            <div className="flex dashboard-header">
                <div className="flex">
                    <Link className={clsx('chips', { 'active': currentTab === 'news' })} to={"/dashboard/latest-news"}>Latest news</Link>
                    <Link className={clsx('chips', { 'active': currentTab === 'investor-updates' })} to={"/dashboard/investor-updates"}>Investor Updates</Link>
                </div>

                {currentTab === 'news' && (<>
                    <div className="search-and-sort-container flex justify-right align-center">
                        <div className="search-container">
                            <input
                                type="text"
                                placeholder="Search keywords or tags ..."
                                onChange={e => setSearchTerm(e.target.value)} />
                        </div>

                        <div className="flex auto-width action-and-sort-container">
                            <button className={`btn-action ${listMode == ListMode.List ? 'active' : ''}`}
                                onClick={() => {
                                    setListMode(ListMode.List);
                                }}>
                                <img src={listIcon} alt="List View" />
                            </button>

                            <button className={`btn-action ${listMode == ListMode.Cards ? 'active' : ''}`}
                                onClick={() => {
                                    setListMode(ListMode.Cards);
                                }}>
                                <img src={cardsIcon} alt="Card View" />
                            </button>

                            <div className="sort-container">
                                <label htmlFor="">Sort by: </label>
                                <a onClick={() => {
                                    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
                                }}>Date</a>
                            </div>
                        </div>
                    </div>
                </>)}
            </div>

            <Outlet context={{ listMode, sortDirection, searchTerm: debouncedValue, currentTab }} />
        </>
    );
}